import { STOP_AUTHENTICATION } from '../constants/actionTypes';

const stopAuthentication = () => {
  return {
    type: STOP_AUTHENTICATION,
  };
};

export default stopAuthentication;
